module.exports = __webpack_public_path__ + "pc/img/teacherNav.480f544.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onOne/teacherNav.png
// module id = N1O4
// module chunks = 3